import React, { ReactNode } from "react";
import styles from "./index.module.scss";

export const FormContainer = ({ children }: { children: ReactNode }) => {
  return <div className={styles.form_container}>{children}</div>;
};
